<template>
  <v-layout align-start>
    <v-flex>
      <v-container fluid>
        <v-row no-gutters justify="center">
          <span style="font-size: 34px; color: #616161">Retenciones</span>
        </v-row>
        <v-card outlined>
          <v-card-text>
            <v-card flat class="mt-0 pt-0">
              <v-card-text class="mt-0 pt-0">
                <v-data-table :headers="headersWithholdings" :search="search" :items="withholdings">
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>Retenciones</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <span>{{ withholdings.length }}</span>
                      <v-spacer></v-spacer>
                      <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Buscar"
                        single-line hide-details>
                      </v-text-field>
                      <v-spacer></v-spacer>
                      <v-divider class="mx-3" inset vertical></v-divider>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn color="primary" class="mr-2" v-bind="attrs" v-on="on" outlined @click="newWithholding()">
                            Nueva retencion
                            <v-icon>add</v-icon>
                          </v-btn>
                        </template>
                        <span>Crear nueva caja</span>
                      </v-tooltip>
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.edit`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" medium color="blue" @click="editWithholdings(item)">
                          edit
                        </v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-dialog v-model="dialogEdit" max-width="50%">
            <v-card outlined>
              <v-card-title class="mb-3">
                <span>{{ titleDialog }}</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogEdit = false">
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container fluid>
                  <v-row justify="center">
                    <v-col cols="12" sm="3" md="12">
                      <v-autocomplete v-model="newWithholdings.category_id" :items="categorys_withholdings"
                        item-value="id" item-text="name" color="cyanText"  label="Tipo de retencion" outlined
                        required>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" md="12">
                      <v-text-field class="text-xs-center" v-model="newWithholdings.name" label="Descripcion" outlined>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="12">
                      <v-text-field class="text-xs-center" v-model="newWithholdings.porcentaje"
                        prepend-inner-icon="percent" label="Porcentaje" type="number" max="100" min="0" outlined>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="3" md="12">
                      <v-autocomplete v-model="newWithholdings.chart_of_account_id" :items="chartOfAccount"
                        item-value="id" item-text="name" color="cyanText"  label="Cuenta contable" outlined
                        required>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" text @click="saveWithholdings()" :loading="loadingSave">
                  {{ nameButon }}
                </v-btn>
                <v-btn color="error" text @click="dialogEdit = false">
                  Cancelar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: () => ({
    search: "",
    withholdings: [],
    categorys_withholdings:[],
    newWithholdings: {
      name: "",
      chart_of_account_id: "",
      percent: 0.0,
      porcentaje: 0,
      category_id: null,

    },
    headersWithholdings: [
      {
        text: "ID",
        align: "start",
        value: "id",
      },
      { text: "Descripcion", value: "name" },
      { text: "Categoria", value: "category_name" },
      { text: "Porcentaje", value: "percent_format" },
      { text: "Cuenta", value: "account" },
      { text: "Editar", value: "edit", sortable: false },
    ],
    dialogEdit: false,
    chartOfAccount: [],
    nameButon: "",
    is_new_Withholdings: true,
    titleDialog: "",
    loadingSave: false,
  }),
  components: {},
  created() {
    this.initialized();
  },
  computed: {},
  watch: {},
  methods: {
    async initialized() {
      this.getData();
      const resultTypeAccounts = await this.api_Get("accounting/accountsUsable");
      let accounts=await resultTypeAccounts.json();
      accounts.forEach(element => {
        element.name=element.name+" (" +element.code+")"
        this.chartOfAccount.push({
          name: element.code+" - "+ element.name,
          id: element.id,
        
        })
      });
    },
    async getData() {
      const request = await this.api_Get("income/withholdings");
      const data = await request.json();
    
      if (request.status == 200) {
        this.withholdings = data;
      }

      const request2 = await this.api_Get("income/withholdings_categories");
      const data2 = await request2.json();
    
      if (request2.status == 200) {
        this.categorys_withholdings = data2;
      }
    },
    editWithholdings(item) {
      this.is_new_Withholdings = false;
      this.titleDialog = "Editar " + item.id + "-" + item.name;
      this.newWithholdings = Object.assign({}, item);
      this.newWithholdings.porcentaje = (item.percent * 100).toFixed(2);
      this.nameButon = "Actualizar";
      this.dialogEdit = true;
    },
    newWithholding() {
      this.clearDialog();
      this.titleDialog = "Nueva retencion ";
      this.nameButon = "Guardar";
      this.dialogEdit = true;
    },
    clearDialog() {
      this.newWithholdings = {
        chart_of_account_id: "",
        percent: 0.0,
        porcentaje: 0,
      };
    },
    async saveWithholdings() {
      this.loadingSave = true;
        if(this.newWithholdings.name==""){
          this.$toast.error("La descripción es obligatoria");
          this.loadingSave = false;
          return;
        }
        
        if(this.newWithholdings.category_id==null){
          this.$toast.error("La categoría es  obligatoria");
          this.loadingSave = false;
          return;
        }
        if(this.newWithholdings.percent<0 || this.newWithholdings.percent>100){
          this.$toast.error("el porcentaje es  obligatoria");
          this.loadingSave = false;
          return;
        }
        if(this.newWithholdings.chart_of_account_id==null ){
          this.$toast.error("La cuenta es  obligatoria");
          this.loadingSave = false;
          return;
        }
      let datos = {
        id: "",
        name: this.newWithholdings.name,
        category_id: this.newWithholdings.category_id,
        percent: this.newWithholdings.porcentaje / 100,
        chart_of_account_id: this.newWithholdings.chart_of_account_id,
        
      };  


      let requSave;
      if (this.is_new_Withholdings == true) {
        requSave = await this.api_Post("income/withholdings", datos);
      } else {
        datos.id = this.newWithholdings.id;
        requSave = await this.api_Put("income/withholdings", datos);
      }
      if (requSave.status === 200) {
        this.$toast.success(
          "Restriccion " + this.is_new_Withholdings == true
            ? "registrada"
            : "actualizada" + " correctamente!"
        );
        this.getData();
        this.dialogEdit = false;
      } else {
        const data = await requSave.json();
        this.$toast.error(data.error);
      }

      this.loadingSave = false;
    },
  },
};
</script>
